export default __webpack_public_path__ + "static/media/springWebFlux.f5bc8a1c.png";